<template>
  <div class="agent-action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="el-dialogs"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="140px">
        <div class="form-flex-box">
          <el-form-item label="消耗积分数:" prop="point">
            <el-input
              v-model.number="params.point"
              size="small"
              placeholder="请输入消耗积分数"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="奖品:" prop="id">
            <el-select
              v-model="params.prize"
              size="small"
              placeholder="请选择奖品"
              filterable
              clearable
              multiple
            >
              <el-option
                v-for="item in prizeBox"
                :value="item.value"
                :label="item.label"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="奖品排序:" prop="sort">
            <el-input
              v-model.number="params.sort"
              size="small"
              placeholder="请输入奖品排序"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select
              v-model="params.status"
              size="small"
              clearable
              placeholder="请选择是否有效"
            >
              <el-option
                v-for="item in enables"
                :value="item.value"
                :label="item.label"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('form')"
          :loading="flag"
          size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  props: {
    prizeBox: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // 外层弹出框
      dialogVisible: false,
      // 弹窗标题
      title: "",
      // 提交按钮状态
      flag: false,
      // 内层弹窗表格加载状态
      loading: false,
      // 编辑id
      id: "",
      // 当前是编辑还是新增
      type: "",
      //图集上传
      actionPics: baseConfig.baseServerUrl + "/vid/uploadStatic",
      // 新增兑换码请求参数
      params: {
        id: undefined,
        point: "",
        prize: "",
        sort: "",
        status: undefined,
      },
      prizeIds: [],
      // 是否激活
      enables: [
        { label: "无效", value: 0 },
        { label: "有效", value: 1 },
      ],
      // 验证规则
      rules: {
        point: [
          { required: true, message: "请选输入消耗积分数", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  methods: {
    openDataSelector() {
      const val = this.params.channel;
      this.$refs.channelSelector.open(val);
    },
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addCode();
          } else if (this.type === "edit") {
            this.editCode();
          }
        } else {
          return false;
        }
      });
    },
    /**
     * 新增
     * @param {object} [params] - 新增接口需要的参数
     * @function [addActivityPrize] - api新增奖品
     */
    addCode() {
      // this.params.prize = [this.prizeIds];
      let params = Object.assign({}, this.params);
      API.addPointsPrice(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success",
            });
            this.$emit("handlerCodeList");
          } else {
            if (res.tip) {
              this.$message.error(this.tip);
            } else {
              this.$message.error("新增失败！");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    /**
     * 修改
     */
    editCode() {
      // this.params.prize = [this.prizeIds];
      let params = Object.assign({}, this.params);
      API.modifyPointsPrice(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.$emit("handlerCodeList");
          } else {
            if (res.tip) {
              this.$message.error(this.tip);
            } else {
              this.$message.error("修改失败！");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        id: undefined,
        point: "",
        prize: "",
        sort: "",
        status: undefined,
      };
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      if (type === "add") {
        this.type = "add";
        this.title = "新增奖品";
      } else {
        this.type = "edit";
        this.title = "编辑奖品";
        this.params = Object.assign({}, data);
        this.params.prize = data.prize
      }
    },
    // 上传成功
    successCallback(res) {
      this.params.image = res.data.coverImg;
    },
  },
};
</script>

<style lang="scss">
.form-flex-box {
  display: flex;
  .el-form-item {
    flex: 1;
  }
  .item-box {
    display: flex;
    flex-direction: column;
  }
}

agent-action-box {
  .checked {
    margin-left: 10px;
  }
}
</style>
